import React from 'react';
import {
  fade,
  withStyles,
  makeStyles,
} from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import './style.css';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(1),
    width: '100%',
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 14,
    width: '98%',
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'box-shadow',
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      boxShadow: `${fade('#e41e26', 0.25)} 0 0 0 0.2rem`,
      borderColor: '#e41e26',
    },
  },
}))(InputBase);

export function CustomTextField({
  label,
  onchange,
  value,
  required,
  name,
  disabled,
  maxLength,
  type,
  onblur,
  className,
  placeholder,
  rows,
  multiline,
}) {
  const classes = useStyles();
  return (
    <FormControl className={classes.margin}>
      <InputLabel shrink htmlFor='bootstrap-input'>
        {label}
      </InputLabel>
      <BootstrapInput
        inputProps={{
          maxLength: maxLength,
          placeholder: placeholder,
        }}
        required={required}
        onChange={onchange}
        value={value}
        name={name}
        disabled={disabled}
        type={type}
        onBlur={onblur}
        className={className}
        multiline={multiline}
        rows={rows}
      />
    </FormControl>
  );
}
